module.exports = __webpack_public_path__ + "img/PersonalData.c2c50c80.svg";